module.exports = __webpack_public_path__ + "static/media/timibit-rewards.59f1a661.png";